import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorPageComponent } from '../_components/error-page/error-page.component';
import { ButtonComponent } from '../_components/buttons/button/button.component';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrl: './forbidden.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorPageComponent, ButtonComponent],
})
export class ForbiddenComponent {
  private readonly router = inject(Router);

  goToDashboard(): void {
    void this.router.navigate(['/dashboard/devices']);
  }
}
